import React from "react";
import "../styles/Info.css";
import {
  FaBars,
  FaList,
  FaHeart,
  FaSort,
  FaUtensils,
  FaCarrot,
  FaBookmark,
  FaSignInAlt,
  FaTrashAlt,
  FaRegHeart,
} from "react-icons/fa";

const Info: React.FC = () => {
  return (
    <div className="info-page">
      <div className="info-content">
        {/* 🔹 LOGO ALKUUN */}
        <img
          src="/images/fiksukaappi_logo.png"
          alt="FiksuKaappi logo"
          className="info-logo"
        />

        <h2>Fiksua kokkausta ilman hävikkiä</h2>

        <p>
          Onko jääkaapissa yksinäinen paprika ja vähän pastaa? FiksuKaappi
          auttaa keksimään niistä jotain järkevää! Lisää sovellukseen, mitä
          aineksia sinulta löytyy, ja saat kätevästi reseptejä, jotka sopivat
          juuri niihin – tai pyydä tekoälyä keksimään jotain uutta ja maukasta.
        </p>

        <p>
          Suuri osa kotitalouksien ruokahävikistä syntyy yksinkertaisesti siitä,
          ettei tiedetä mitä tehdä jääkaappiin unohtuneista aineksista.
          FiksuKaappi auttaa hyödyntämään nämä raaka-aineet ennen kuin ne
          päätyvät biojätteeseen – ja samalla säästät rahaa, luonnonvaroja ja
          vähennät ympäristökuormitusta.
        </p>

        <h3>FiksuKaappi – käyttöohje</h3>

        <h4>Kirjautuminen</h4>
        <ul>
          <li>
            Voit käyttää sovellusta ilman kirjautumista, mutta raaka-aineet
            eivät säily istunnon yli.
          </li>
          <li>
            Kirjautumalla palveluun
            <FaSignInAlt style={{ color: "#a5f865", margin: "0 4px" }} /> (Magic
            Link / Google) voit:
            <ul>
              <li>
                Voit hyödyntää kauppalistatoimintoa{" "}
                <FaList style={{ color: "#a5f865", margin: "0 4px" }} />
              </li>
              <li>
                Tallentaa suosikkireseptejä{" "}
                <FaHeart style={{ color: "#a5f865", margin: "0 4px" }} />
              </li>
              <li>
                Mahdollisuuden tallentaa tekoälyn luomia reseptejä{" "}
                <FaBookmark style={{ color: "#a5f865", margin: "0 4px" }} />
              </li>
            </ul>
          </li>
        </ul>

        <h4>Ruokakomeron käyttö</h4>
        <ol>
          <li>
            Siirry Ruokakomero-näkymään.{" "}
            <FaCarrot style={{ color: "#a5f865", margin: "0 4px" }} />
          </li>
          <li>
            Lisää raaka-aineita syöttökenttään. Voit valita valmiista listasta
            tai syöttää omia raaka-aineita (vaikka lohikäärmeen kynsiä).
          </li>
          <li>Raaka-aineet näkyvät värikoodatuissa ryhmissä.</li>
          <li>
            Voit poistaa yksittäisiä aineita tai tyhjentää koko ruokakomeron
            painamalla roskakori-ikonia{" "}
            <FaTrashAlt style={{ color: "#a5f865", margin: "0 4px" }} />
          </li>
          <li>
            Voit lajitella raaka-aineet kategorioittain tai aakkosjärjestykseen
            <FaSort style={{ color: "#a5f865", margin: "0 4px" }} />
          </li>
        </ol>

        <h4>Reseptien haku</h4>
        <ol>
          <li>
            Siirry Reseptihaku-näkymään{" "}
            <FaUtensils style={{ color: "#a5f865", margin: "0 4px" }} />
          </li>
          <li>
            Valitse ensin haluamasi ruokalaji tai suosikit ylälaidan
            alavetovalikosta
          </li>
          <li>
            <FaBars style={{ color: "#a5f865", margin: "0 4px" }} /> painiketta
            painamalla voit suodattaa hakuja erityisruokavaliojen mukaan.
          </li>
          <li>
            Klikkaa:
            <ul>
              <li>
                <strong>Hae reseptejä</strong> – hakee valmiita reseptejä
                tietokannasta.
              </li>
              <li>
                <strong>AI-resepti</strong> – tekoäly ehdottaa reseptiä
                ruokakomerosi raaka-aineiden pohjalta.{" "}
                <strong>
                  Näihin kannattaa suhtautua skeptisesti ja huumorillakin.
                </strong>
              </li>
            </ul>
          </li>
          <li>
            Tulokset näkyvät kortteina. Ylimpänä näkyvät ne reseptikortit joihin
            löytyy eniten raaka-aineita ruokakomerosta. Reseptikortilta pystyt:
            <ul>
              <li>
                Tarkistamaan mitkä raaka-aineet ovat (vihreä/punainen merkintä)
                ruokakomerossasi
              </li>
              <li>
                Lisätä puuttuvat raaka-aineet kauppalistaan
                <FaList style={{ color: "#a5f865", margin: "0 4px" }} />{" "}
                (kirjautuneena){" "}
              </li>
              <li>
                Lisätä reseptin suosikkeihin{" "}
                <FaRegHeart style={{ color: "#a5f865", margin: "0 4px" }} />{" "}
                (kirjautuneena){" "}
              </li>
              <li>
                Reseptikortin alalaidassa olevasta "siirry reseptiin"
                painikkeesta siirryt reseptintarjoajan sivulle josta näet koko
                reseptin
              </li>

              <li>Tallentaa AI-reseptin, jos olet kirjautuneena</li>
            </ul>
          </li>
        </ol>

        <h4>Kauppalistan käyttö</h4>
        <p>
          Voit lisätä reseptistä puuttuvat raaka-aineet suoraan omaan
          kauppalistaasi klikkaamalla reseptikortin oikeassa laidassa olevaa
          lista ikonia <FaList style={{ color: "#a5f865", margin: "0 4px" }} />.
          Kaikki lisäykset tallentuvat omaan kauppalistaasi.
        </p>
        <p>
          Kauppalistasta voit helposti poistaa yksittäisiä aineksia tai
          tyhjentää koko listan. Kauppalista vaatii kirjautumisen.
        </p>

        <h4>Reseptien tallentaminen suosikeiksi</h4>
        <p>
          Klikkaamalla <strong>sydänikonia</strong> reseptikortin oikeassa
          laidassa voit tallentaa reseptin suosikiksi. Voit poistaa reseptin
          suosikeistasi painamalla sydänikonia uudelleen.
        </p>
        <p>
          Suosikit toimivat vain kirjautuneille käyttäjille ja näkyvät
          valittavina hakuvaihtoehdoissa Suosikit.
        </p>
        <h4>Tallennetut reseptit</h4>
        <ul>
          <li>Tallennetut AI-reseptit löytyvät Tallennetut-näkymästä.</li>
          <li>Voit poistaa reseptejä painamalla Poista resepti -painketta.</li>
        </ul>
        <h4>Vinkkejä</h4>
        <ul>
          <li>
            Lisää vähintään 2 raaka-ainetta, jotta tekoäly osaa ehdottaa
            reseptejä.
          </li>
          <li>Reseptejä lisätään sovellukseen säännöllisesti.</li>
          <li>
            Sovellusta voi käyttää mobiililaitteella tai tietokoneella – ulkoasu
            on kuitenkin toisaiseksi suunnattu mobiilikäyttöön.
          </li>
        </ul>
        <h3>Tietosuoja ja käyttäjätiedot</h3>

        <p>
          FiksuKaappi kunnioittaa yksityisyyttäsi. Sovelluksessa kerätään ja
          tallennetaan vain välttämättömät tiedot:
        </p>
        <ul>
          <li>sähköpostiosoite ja profiilinimi kirjautumisen yhteydessä</li>
          <li>lisäämäsi raaka-aineet ja tallennetut reseptit</li>
        </ul>

        <p>
          Käyttäjätiedot tallennetaan turvallisesti <strong>Supabasen</strong>{" "}
          pilvipalveluun. Voit kirjautua joko{" "}
          <strong>Google-tunnuksillasi</strong> tai pyytää kirjautumislinkin
          sähköpostiisi, jolloin viesti toimitetaan <strong>ZeptoMailin</strong>{" "}
          kautta.
        </p>

        <p>
          Vierailijat voivat käyttää sovellusta ilman kirjautumista – tällöin
          tiedot säilyvät vain istunnon ajan selaimen muistissa.
        </p>

        <p>
          Tulevaisuudessa saatamme hyödyntää anonyymia analytiikkaa palvelun
          kehittämiseksi. Mikäli näin tehdään, tiedot eivät ole yhdistettävissä
          yksittäiseen käyttäjään.
        </p>

        <p>
          Voit milloin tahansa poistaa käyttäjätilisi ja siihen liittyvät tiedot
          valikosta kohdasta
          <strong> Profiili</strong> → <strong>Poista tili</strong>.
        </p>

        <h3>Ota yhteyttä</h3>
        <p>
          Jos haluat antaa palautetta, ehdottaa uusia reseptejä tai kysyä
          jotain, voit ottaa yhteyttä sähköpostitse:
          <br />
          <strong>info [at] fiksukaappi.fi</strong>
        </p>
      </div>
    </div>
  );
};

export default Info;
